import { Stack, Text, Title } from '@mantine/core';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { SecurityLog, type SecurityLogProps } from '../components/Security/SecurityLog';

export interface SecurityLogPageProps extends SecurityLogProps {
  /**
   * Optional banner rendered above the log. Apps pass an `<OidcSecurityLogBanner>`
   * here for OIDC-method sessions so the user knows additional sign-in events
   * are visible at the IdP.
   */
  banner?: ReactNode;
}

export function SecurityLogPage({ banner, ...props }: SecurityLogPageProps) {
  const { t } = useTranslation();
  return (
    <>
      <Stack gap={4} mb="lg">
        <Title order={1} size="h2" fw={600} style={{ letterSpacing: '-0.01em' }}>
          {t('securityLog.title', 'Security log')}
        </Title>
        <Text size="sm" c="dimmed" lh={1.5}>
          {t('securityLog.description')}
        </Text>
      </Stack>
      {banner}
      <SecurityLog {...props} />
    </>
  );
}
